module.exports = __webpack_public_path__ + "img/startips.ccaf5096.png";